import { useReduxState } from 'hooks';

interface Props {
  customContent: string;
}

const PageCustomContent = ({ customContent }: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="page-custom-content">
      <div
        dangerouslySetInnerHTML={{
          __html: customContent
        }}
      />

      <style jsx>{`
        .page-custom-content {
          color: ${theme.textColorLight};
          font-size: 1.5rem;
        }
        .page-custom-content :global(p) {
          margin: 15px 0 0;
        }
        .page-custom-content :global(p:first-child) {
          margin-top: 0;
        }
      `}</style>
    </div>
  );
};

export default PageCustomContent;
